module.exports = __webpack_public_path__ + "img/6.cbf76c60.svg";